module.exports = __webpack_public_path__ + "img/20221130_151801.1cbffa18.png";